import BiBuildings from '@meronex/icons/bi/BiBuildings';
import icon from './StyledIcon';
export default icon(BiBuildings);
